<template>
  <div>
    <h6
      :style="{visibility: listCount > 0 ? 'visible' : 'hidden'}"
    >Unique solutions found: {{ listCount }}</h6>
    <div>
      <ul class="list-group">
        <li
          class="list-group-item"
          v-for="(solution, index) in uniqueSolutionsList"
          :key="index"
          @click="selectSolution(index)"
        >
          {{ solution[0].join('+')}} =
          {{ solution[1].join('+')}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["uniqueSolutionsList"],
  computed: {
    listCount() {
      return this.uniqueSolutionsList.length;
    },
  },
  methods: {
    selectSolution(index) {
      this.$emit("selectSolution", index);
    },
  },
};
</script>

<style scoped>
.list-group-item {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  cursor: pointer;
}
</style>